import { createFileRoute } from '@tanstack/react-router'
import { JudgeProfileView } from '@workspace/seedforge-ui/evaluation'
import { Loader2 } from 'lucide-react'
import { FounderLayout } from '../../../../components/founder-layout'
import { useJudgeProfileQuery } from '../../../../hooks/api'
import { useBasePath } from '../../../../hooks/use-base-path'

export const Route = createFileRoute('/app/startup/$id/judge/$judgeKey/$evaluationId')({
  component: JudgePage,
})

function JudgePage() {
  const { id: startupId, judgeKey, evaluationId } = Route.useParams()
  const basePath = useBasePath()
  const { data, isLoading, error } = useJudgeProfileQuery(startupId, evaluationId, judgeKey)

  if (isLoading) {
    return (
      <FounderLayout activeNav="">
        <div className="flex h-64 items-center justify-center">
          <Loader2 className="size-6 animate-spin text-muted-foreground" />
        </div>
      </FounderLayout>
    )
  }

  if (error || !data?.data) {
    return (
      <FounderLayout activeNav="">
        <div className="flex h-64 items-center justify-center text-muted-foreground">
          Judge not found
        </div>
      </FounderLayout>
    )
  }

  return (
    <FounderLayout activeNav="">
      <JudgeProfileView judge={data.data} backTo={`${basePath}/evaluation/${evaluationId}`} />
    </FounderLayout>
  )
}
